import { forwardRef, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import iamRoutes from '../routes/iamRoutes';
import publicRoutes from '../routes/publicRoutes';

import * as actions from '../store/actions/index';
import PageNotFound from '../pages/PageNotFound';
import MaintenanceMode from './MaintenanceMode';
import LogOut from './auth/LogOut';
import PageNotAuthorize from './includes/ui/PageNotAuthorize';
import Login from './auth/Login';
import AppInitializeScreen from '../pages/AppInitializeScreen/AppInitializeScreen';
import { getToken, systemRef, messaging, onValue } from '../services/firebase';

const App = forwardRef((props, ref) => {

    const dispatch                  =   useDispatch();
    const isAuthenticated           =   useSelector(state => state.auth.access_token !== null);
    const isAppInitialized          =   useSelector(state => state.app.user_info ? true : false);
    const app_iam_data_loaded       =   useSelector(state => state.app.app_iam_data_loaded);
    const app_isc_data_loaded       =   useSelector(state => state.app.app_isc_data_loaded);
    const access_token              =   useSelector(state => state.auth.access_token);
    const firebase_fcm_token        =   useSelector(state => state.app.firebase_fcm_token);
    const group_modules             =   useSelector(state => state.app.acl_info && state.app.acl_info.group_modules ? state.app.acl_info.group_modules : []);
    const groupSubModules           =   useSelector(state => state.app.acl_info && state.app.acl_info.group_sub_modules ? state.app.acl_info.group_sub_modules : []);
    const permissions               =   useSelector(state => state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []);
    const appData                   =   useSelector(state => state.app ? state.app : null);
    // const REACT_APP_ENV             =   process.env.REACT_APP_ENV;
    const REACT_APP_ENV             =   'production';

    const firebaseInit              = async () => {
        // Initialize Firebase
        onValue(systemRef, (snapshot) => {
            const fbData = snapshot.val();
            const data = fbData ? fbData : null;
            dispatch(actions.fireBaseSystemConfigUpdate(data));
        });
        // Request permission for notifications and get FCM token :-
        let fcsToken        =   'blocked';
        try {
            const permission = await Notification.requestPermission();
            if (permission === "denied") {
                toast('You have blocked notifications. Please enable from browser settings.');
            } else if (permission === "default") {
                toast('You have not yet decided about notifications. Please enable from browser settings.');
            } else if (permission === "granted") {
                fcsToken        =   await getToken(messaging, { vapidKey: 'BPren2duxa4Ks32rwqvQVSiQLq3Z3DdakOLhQtH8ClydZhCWdMv3jiveGb4eiFTjySdBtDFP8n41te_zxd3XHbs'});
            }
            if (fcsToken) {
                dispatch(actions.fireBaseCloudMessageUpdate(fcsToken));
            } 
        } catch (error) {
            toast("An error occurred while initializing Firebase or getting FCM token : " + error.message);
            dispatch(actions.fireBaseCloudMessageUpdate(fcsToken));
        }
    };

    useEffect(() => {
        //Initialize Firebase only in production environment
        if (REACT_APP_ENV === 'production') {
            firebaseInit();
        }
        dispatch(actions.authCheckState());
    }, [dispatch]);

    useEffect(() => {
        access_token && firebase_fcm_token && firebase_fcm_token !== 'blocked' && dispatch(actions.appFirebaseFCMTokenSaveInit(access_token, firebase_fcm_token));
    }, [firebase_fcm_token, access_token])


    const urlPermissionAccess           =   (route, permissions)  =>  {
        let access  = false;
        if(route.hasOwnProperty('permission') && route.permission != '') {
            if(route.permission && permissions.includes(route.permission)) {
                access = true;
            }
        } else {
            access = true;
        }
        return access;
    }

    let tbRoutes                        =   publicRoutes;
    let group_sub_modules               =   groupSubModules.map(s => s.sub_module);
    tbRoutes                            =   Array.isArray(tbRoutes) ? [...tbRoutes] : (tbRoutes ? [...tbRoutes] : []);
    let notPermssionRoutes              =   [];
    let appInitilizatedNDataLoaded      =   isAppInitialized && app_iam_data_loaded;
    if(group_modules.includes('isc')) {
        appInitilizatedNDataLoaded      =   isAppInitialized && app_iam_data_loaded && app_isc_data_loaded;
    }

    if (appInitilizatedNDataLoaded && isAuthenticated) {
        iamRoutes.forEach((route, rk) => {
            if(route.hasOwnProperty('subModule') && route.subModule != '') {
                if(route.subModule && group_sub_modules.includes(route.subModule) && urlPermissionAccess(route, permissions)) {
                    tbRoutes.push(route);
                } else {
                    notPermssionRoutes.push(route);
                }
            } else {
                if(urlPermissionAccess(route, permissions)) {
                    tbRoutes.push(route);
                } else {
                    notPermssionRoutes.push(route);
                }
            }
        });
    }

    let screens = <></>;
    if (process.env.REACT_APP_ENV == 'production' && appData && appData.firebase_maintenance_mode === 'Y') {
        screens  =  <MaintenanceMode />;
    } else if (isAuthenticated && !appInitilizatedNDataLoaded) {
        screens = <AppInitializeScreen />;
    } else {
        screens = 
            <Router>
                <Switch>
                <Route path={'/logout'} exact={true} component={LogOut} />
                {tbRoutes.map((v, i) => <Route path={v.path} exact={v.exact} key={i} component={v.component} />)}
                {notPermssionRoutes.map((v, i) => <Route path={v.path} exact={v.exact} key={i} component={PageNotAuthorize} />)}
                <Route path='*' component={isAuthenticated ? PageNotFound : Login} />
            </Switch>
        </Router>
    }

    return <>
        <ToastContainer />
        {screens}
    </>
});
export default App;

